<template>
  <div ref="verification" class="verification" redesign>
    <!-- Redirect to home if not logged in -->
    <template v-if="userIsLoggedIn">{{ this.$router.push({ name: 'Home' }) }}</template>

    <!-- Header -->
    <StepProgressBar step1 />

    <div class="request-form form-container">
      <!-- Hardship definition -->
      <div class="form-field">
        <div class="hardship-definition eligibility-list" v-html="hardshipDefinition"></div>
      </div>

      <!-- Eligibility list -->
      <div class="form-field">

        <div v-if="eligibilityList" class="eligibility-list" v-html="eligibilityList"/>
        <div v-else="eligibilityList" class="eligibility-list">
          <p v-translate>If your emergency is eligible, the next step is to submit a grant request. To make a grant request, you will need to:</p>
          <ul>
            <li>
              <span v-translate>Describe your emergency</span>
            </li>
            <li v-if="organizationDetails.eventDocumentationEnabled">
              <span v-translate>Document the details and out-of-pocket costs of your emergency</span>
            </li>
            <li v-if="!organizationDetails.eventDocumentationEnabled">
              <span v-translate>Describe the details and out-of-pocket costs of your emergency</span>
            </li>
            <li>
              <span v-translate>Review and submit your request</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="fraudWarning" class="fraud-warning" v-html="fraudWarning"></div>
    </div>

    <div class="button-container">
      <!-- Employee code -->
      <button
        @click="submit"
        class="form-button"
      >
        <span key="verify" v-translate>Continue</span>
      </button>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LoadSpinner from '../components/LoadSpinner'
import EmployeeCode from '@/services/employeeCodes'
import StepProgressBar from '@/components/stepper/StepProgressBar'
import { analyticsMixin } from '@/services/googleAnalytics'
import { translateToCurrentLang, formatValue, formatText } from '@/services/utils'
import PinwheelApi from '@/services/pinwheel'
import UserEvent from '@/services/userEvents'

export default {
  name: 'Qualification',
  mixins: [analyticsMixin],
  components: {
    StepProgressBar,
    LoadSpinner,
  },
  data() {
    return { }
  },
  beforeMount() {
    // If the user is logged in redirect to the home page
    if (this.userIsLoggedIn) {
      this.$router.push({ name: 'Home' })
    }
  },
  methods: {
    submit() {
      this.$router.push({
        name: 'Verification',
      })

    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentLanguage']),
    ...mapGetters(['userIsLoggedIn']),
    hardshipDefinition() {
      const varMap = { org: this.organizationDetails }
      return formatValue(this.organizationDetails.hardshipDefinitionCopy, varMap)
    },
    fraudWarning() {
      const varMap = { org: this.organizationDetails }
      if (this.organizationDetails.fraudWarningCopy) {
        return formatValue(this.organizationDetails.fraudWarningCopy, varMap)
      }
    },
    eligibilityList() {
      const varMap = { org: this.organizationDetails }
      if (this.organizationDetails.eligibilityListCopy) {
        return formatValue(this.organizationDetails.eligibilityListCopy, varMap)
      }
    }

  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/grant-circles';
@import '@/styles/mixins/responsive';

.verification {
  display: flex;
  flex-direction: column;

  .fraud-warning {
    padding: 0.5rem;
    color: red;
  }

  .request-form {
    max-width: 704px;
    align-self: center;

    @include desktop-screen {
      max-width: 1076px;
      align-self: center;
    }

    text-align: left;

    .eligibility-list {
      ::v-deep p:first-of-type {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 2rem;
      }

      ::v-deep ul {
        display: flex;
        flex-direction: column;
        list-style: none;
        padding-left: 0.5rem;
      }

      ::v-deep li {
        display: flex;
        flex-direction: row;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-bottom: 1rem;
        margin-left: 0;

        &::before {
          background: $black;
          border-radius: 50%;
          content: '';
          position: relative;
          top: 6px;
          height: 12px;
          width: 12px;
          min-width: 12px;
          max-width: 12px;
          margin-right: 1rem;
        }
      }
    }
  }

  .verify-form {
    max-width: 453px;
    width: 100%;

    align-self: center;

    @extend .card-shape;

    .verify-form-footer {
      text-align: center;

      .sign-in-text {
        line-height: 1rem;
      }
    }
  }

  .form-header {
    margin-bottom: 0;
  }

  .sub-org-select-form-header {
    align-self: center;
  }

  .sub-org-select-form {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-self: center;
    justify-content: space-evenly;

    @include tablet-and-up-screen {
      flex-direction: row;
      width: 100%;
      max-width: 800px;
      margin-top: 1.5rem;
    }



    .sub-org {
      @extend .card-shape;

      display: flex;
      cursor: pointer;
      align-content: center;
      justify-content: center;
      margin-bottom: 1.5rem;

      @include tablet-and-up-screen {
        height: 90px;
      }

      &:hover {
        background-color: #ececec;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      span {
        text-decoration: underline;
      }
    }
  }
}
</style>
